import React, { useState } from "react";

export const SWCContent = () => {
    const [offset, setOffset] = useState(1);
    const [zoom, setZoom] = useState(0.9);
  
    return (
      <div className="">
        {/* Offset control buttons */}
        <div className="flex gap-[4px] text-sm items-center">
          {[1, 2, 3].map((num) => (
            <button
              key={num}
              style={{
                backgroundColor: offset === num ? "#2f5f9b" : "transparent",
                color: offset === num ? "white" : "#2f5f9b",
                border: "1px solid #2f5f9b",
                padding: "4px 8px",
              }}
              onClick={() => setOffset(num)}
            >
              {num === 1 ? "Latest" : `Offset ${num}`}
            </button>
          ))}
          
          {/* Zoom controls */}
          <div className="flex gap-[4px] ml-2">
            <button
              style={{
                backgroundColor: "#2f5f9b",
                color: "white",
                border: "1px solid lightgray",
                padding: "4px 8px",
                width: "30px"
              }}
              onClick={() => setZoom(prev => Math.max(0.5, prev - 0.1))}
              disabled={zoom <= 0.5}
            >
              -
            </button>
            <button
              style={{
                backgroundColor: "#2f5f9b",
                color: "white",
                border: "1px solid lightgray",
                padding: "4px 8px",
                width: "30px"
              }}
              onClick={() => setZoom(prev => Math.min(2, prev + 0.1))}
              disabled={zoom >= 2}
            >
              +
            </button>
          </div>
        </div>
  
        {/* Image display */}
        <img
          style={{ 
            width: "100%", 
            maxWidth: "700px", 
            transform: `scale(${zoom})`,
            transformOrigin: "top left",
            margin: "10px 0"
          }}
          src={`https://api.met.no/weatherapi/sigcharts/2.0/?area=nordic&offset=${offset}`}
          alt="SWC"
        />
      </div>
    );
};